import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import ActionButton from "../../../components/ActionButton";
import TextInputField from "../../../components/forms/TextInputField";
import FormError from "../../../components/forms/FormError";

class CommitSubscriptionPricelistForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, message} = this.props;
    let submitLabel = submitting ? "Standby..." : this.props.submitLabel; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>{message}</p>
          <FormFieldsTable>
            <Field 
              label="Specify a new version (e.g. 2025-01-01)"
              name="version"
              component={TextInputField}
              serverError={this.props.errors.version}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton show={this.props.showCancel} label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

CommitSubscriptionPricelistForm.defaultProps = {
  message: "A message",
  submitLabel: "Submit",
  showCancel: true
}

const ReduxForm = reduxForm({
  form: "CommitSubscriptionPricelistForm"
})(CommitSubscriptionPricelistForm);

export default ReduxForm;